/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedHeadMetaTags_node$ref: FragmentReference;
export type SharedHeadMetaTags_node = {|
  +photos: ?$ReadOnlyArray<?{|
    +versions: ?$ReadOnlyArray<?{|
      +webPath: ?string
    |}>
  |}>,
  +$refType: SharedHeadMetaTags_node$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedHeadMetaTags_node",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": "photos(limit:1,skipImageService:true)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "skipImageService",
          "value": true,
          "type": "Boolean"
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f4f0525c657ec69fb90328f7a97d12c4';
module.exports = node;
